import React, { useEffect, useMemo, useRef, useState } from 'react'
import styles from "./Circle.module.css"
import polycolor from ".././../assets/PolygonColor.svg"
import polyWhite from ".././../assets/PolygonWhite.svg"
export function useOnScreen(ref) {

    const [isIntersecting, setIntersecting] = useState(false)

    const observer = useMemo(() => new IntersectionObserver(
        ([entry]) => setIntersecting(entry.isIntersecting)
    ), [ref])


    useEffect(() => {
        observer.observe(ref.current)
        return () => observer.disconnect()
    }, [])
    // //console.log(isInters ecting);
    return isIntersecting
}
function Circle() {
    const ref1 = useRef()
    const isVisible = useOnScreen(ref1)
    return (


        <div ref={ref1} className={`${styles.ServiceRight}`}>

            <div className={styles.mainCircle}>
                <p className={styles.centerText}>PROBLEM</p>
                <div className={styles.arrowIconTop}>
                    <img src={polycolor} alt = "Arrow" />
                    <img src={polyWhite}  alt  = "Arrow" />
                </div>
                <div className={styles.arrowIconLeft}>
                    <img src={polycolor} alt = "Arrow" />
                <img src={polyWhite}  alt  = "Arrow" />
                </div>
                <div className={styles.arrowIconRight}>
                    <img src={polycolor} alt = "Arrow" />
                <img src={polyWhite}  alt  = "Arrow" />
                </div>
            </div>


            <div

                className={`${styles.cricle1} ${isVisible? styles.AnimateLeft:""}`}>
                <p >International <br /> Network</p>
            </div>
            <div

                className={`${styles.cricle2} ${isVisible? styles.AnimateRight:""}`}>
                <p >Business <br /> Professional</p>
            </div>
            <div

                className={`${styles.cricle3} ${isVisible? styles.AnimateTop:""}`}>
                <p style={{ color: "#fff" }}>IT <br /> Professional</p>
            </div>
        </div>

    )
}

export default Circle